export const detect = async (
  net,
  webcamRef,
  canvasRef,
  vectors,
  diffVectors
) => {
  if (
    typeof webcamRef.current !== "undefined" &&
    webcamRef.current !== null &&
    webcamRef.current.video.readyState === 4
  ) {
    // Get Video Properties
    const video = webcamRef.current.video;
    const videoWidth = webcamRef.current.video.videoWidth;
    const videoHeight = webcamRef.current.video.videoHeight;

    // Set video width
    webcamRef.current.video.width = videoWidth;
    webcamRef.current.video.height = videoHeight;

    // Set canvas width
    // canvasRef.current.width = videoWidth;
    // canvasRef.current.height = videoHeight;

    // Make Detections
    // NEW MODEL
    const face = await net.estimateFaces({ input: video });

    if (face["0"]) {
      vectors.mouth.push({ measure: face["0"].annotations.lipsLowerInner });

      return { vectors, diffVectors };
    }

    return false;

    // Get canvas context
    // const ctx = canvasRef.current.getContext("2d");
    // requestAnimationFrame(() => {
    // drawMesh(face, ctx);

    // });
  }
};
